module.exports = __webpack_public_path__ + "static/media/avado-logo-v1.1.18c0802f.svg";